import React from 'react';
import moment from 'moment';

const IncidentDetails = ({ incident }) => {
  return (
    <div
      id="incidentDetail"
      className="modal fade in"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title text-center" id="myModalLabel">
              Incident report Details
            </h4>
            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
              ×
            </button>
          </div>
          <div className="modal-body detail" style={{ padding: '0', textAlign: 'justify' }}>
            <div className="row">
              <div className="col-lg-12 d-flex">
                <div className="col-lg-4 detail-label1">
                  {/* <label id="bs">Basestation</label> */}
                  <label id="des">Description</label>
                  <label id="affected">System affected</label>
                  <label id="impact">Impact</label>
                  <label id="duration">Start Time</label>
                  <label id="duration">End Time</label>
                  <label id="date">Date</label>
                  <label id="resolution">Resolution team</label>
                </div>

                <div className="col-lg-8 detail-result1">
                  {/* <p className="mt-4 mb-1">Agungi One</p> */}
                  <p className="mt-4 mb-1">{incident.description}</p>
                  <p className="mb-1">{incident.system_affected}</p>
                  <p className="mb-1">{incident.impact}</p>
                  <p className="mb-1">{incident.duration_start_time}</p>
                  <p className="mb-1">{incident.duration_end_time}</p>
                  <p className="mb-1">{moment(incident.created_at).format('YYYY-MM-DD')}</p>
                  <p className="mb-1">{incident.resolution_team}</p>
                </div>
              </div>
              <hr />
              {/* <div className="col-lg-12 d-flex">
                                    <div className="col-lg-4 detail-label2">
                                        <label id="phone1">Notification source </label>
                                        <label id="email1">Department notified</label>
                                        <label id="address">Required action</label>
                                    </div>

                                    <div className="col-lg-8 detail-result2">
                                        <p className="mt-4 mb-1">Basestation one</p>
                                        <p className="mb-1">Ops</p>
                                        <p className="mb-1 mt-2">More checks</p>
                                    </div>
                                </div> */}

              <div className="col-lg-12 d-flex">
                <div className="col-lg-4 detail-label3">
                  <label id="plan">Root cause</label>
                  <label id="source">Fix actions</label>
                  <label id="notes">Changes made</label>
                  <label id="cofirmation">Confirmation</label>
                </div>

                <div className="col-lg-8 detail-result3">
                  <p className="mt-4 mb-1">{incident.root_cause}</p>
                  <p className="mb-1">{incident.fix_actions}</p>
                  <p className="mb-1">{incident.changes_made}</p>
                  {incident.confirmation_of_resolution === false ? (
                    <p className="mb-1">Not Resolved</p>
                  ) : (
                    <p className="mb-1">Resolved</p>
                  )}
                  {/* <p className="mb-1">{incident.confirmation_of_resolution}</p> */}
                </div>
              </div>

              <div className="col-lg-12 d-flex">
                <div className="col-lg-4 detail-label4">
                  <label id="date">Cause of incident</label>
                  <label id="prevention">Prevention</label>
                  <label id="additional">Additional actions</label>
                  {/* <label id="reported">Reported By</label> */}
                </div>

                <div className="col-lg-8 detail-result4">
                  <p className="mt-4 mb-1">{incident.cause_of_incident}</p>
                  <p className="mb-1">{incident.incidence_prevention}</p>
                  <p className="mb-1">{incident.additional_action}</p>
                  {/* <p className="mb-1">Ehimen</p> */}
                </div>
              </div>

              {/* <div className="col-lg-12 text-center p-3">
                                    <button className="btn btn-second">Edit</button>
                                </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncidentDetails;
